import { render, staticRenderFns } from "./Create-File-Dialog.vue?vue&type=template&id=271f1802&scoped=true&"
import script from "./Create-File-Dialog.vue?vue&type=script&lang=js&"
export * from "./Create-File-Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Create-File-Dialog.vue?vue&type=style&index=0&id=271f1802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f1802",
  null
  
)

export default component.exports